import { Chip, Divider } from "@mui/material";
import { useTranslations } from "use-intl";
import { ExpandableSection } from "../ExpandableSection";
import type { FindHotelsOutputData } from "@/app/lib/types/codegen";

type Props = {
  hotel: FindHotelsOutputData;
};

export const HotelFacilities = ({ hotel }: Props) => {
  const t = useTranslations();

  const facilities = hotel.descriptions?.facilities?.split(",");

  if (!facilities) return null;

  return (
    <>
      <Divider
        sx={{
          borderColor: "var(--color-stroke-neutral-softer)",
          my: "calc(var(--spacing)*4)",
        }}
      />
      <div className="mb-4 font-medium text-text-tertiary">
        {t("hotels.overview.facilities")}
      </div>
      <ExpandableSection>
        <ul className="flex flex-wrap gap-2">
          {facilities.map((facility) => (
            <li key={facility}>
              <Chip
                label={facility}
                sx={{
                  bgcolor: "var(--color-surface-neutral-soft)",
                  color: "var(--color-text-primary)",
                  fontSize: "var(--text-sm)",
                  borderRadius: "var(--radius-lg)",
                  padding: "4px 8px",
                  "& .MuiChip-label": {
                    padding: 0,
                  },
                }}
              />
            </li>
          ))}
        </ul>
      </ExpandableSection>
    </>
  );
};
